/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M0 9v2h50V9zm0 15v2h50v-2zm0 15v2h50v-2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/icon_menu.js